export const environment = {
    production: true,
    apiUrl: 'https://tgnv12.smartworkar.com:8888',
    frontUrl: '',
    urlAssets: 'http://localhost:4200',
    urlBack: 'https://tgn-auditoria-back.candoit.com.ar',
    user: {
        username: "tgntesting@vreadynow.com",
        password: "larealidadesvirtual"
    }

};